export const inputPrompts = {
  uniqueName: 'Please enter a unique group name',
  addGroupAdmin: 'Please add a group administrator',
};

export const requestErrors = {
  uniqueName: 'This must be a unique name',
  blankName: "Name can't be blank",
  nameAlreadyExists:
    'A group with this name already exists. Please enter a unique group name.',
  mustHaveAdmin: 'Approval group users must have at least one Administrator',
  error: 'This content isn’t available at the moment. Please try again later.',
};

export const approvalsGroupText = {
  admins: {
    title: 'Group Administrators',
    description:
      'Select users who can approve all orders and receive all approval notifications',
    cta: 'Add Administrators',
  },
  approvers: {
    title: 'Approvers',
    description: 'Select users to approve orders within this group',
    cta: 'Add Approvers',
  },
  users: {
    title: 'Standard Users',
    description: 'Select users who require approval in this group',
    cta: 'Add Users',
  },
  btns: {
    submit: 'Create Group',
    cancel: 'Cancel',
  },
};
